// Same gateway origin resolution as register-api.ts — absolute URL so the
// standalone VerifyApp (pre-router, before Keycloak) reaches the gateway directly.
const GATEWAY_URL =
  (import.meta.env.VITE_GATEWAY_URL as string | undefined) ??
  (import.meta.env.VITE_GRAPHQL_URL as string | undefined)?.replace(/\/graphql\/?$/, '') ??
  'http://localhost:4000';

const VERIFY_URL = `${GATEWAY_URL}/auth/verify`;

export type VerifyOutcome =
  | { ok: true }
  | { ok: false; reason: 'invalid_or_expired' | 'network_error' };

/**
 * POST /auth/verify — public, no Authorization header.
 * Atomically burns the single-use VERIFY_EMAIL token and marks the KC user
 * email-verified. Single-use: a second call with the same token returns
 * invalid_or_expired (same error as expired / malformed tokens).
 *
 * Security: this is a POST, not GET, so email-client prefetchers cannot burn
 * the token by fetching the emailed link. The FE page is the GET; THIS is the
 * consume. (DD §9 R2)
 */
export async function postVerifyEmail(token: string): Promise<VerifyOutcome> {
  try {
    const res = await fetch(VERIFY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    });
    if (res.ok) return { ok: true };
    return { ok: false, reason: 'invalid_or_expired' };
  } catch {
    return { ok: false, reason: 'network_error' };
  }
}
